import React from 'react'
import { motion } from 'framer-motion'
import UserList from '../support/UserList'

const UserManagementSettings: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      role='tabpanel'
      id='users-panel'
      aria-labelledby='users-tab'
    >
      {/* User List Component - it has its own header */}
      <UserList />
    </motion.div>
  )
}

export default UserManagementSettings
